export default {
    cptDataForm:{
        dataText: '{"options":[{"label":"导航1","value":"op1"},{"label":"导航2","value":"op2"},{"label":"导航3","value":"op3"}]}',
        apiUrl:'/tab', sql:'',dataSource: 1, pollTime: -1
    },
    attribute: {
        space: 4,bgColor: '#242424',bgColorActive: '#699ef5',autoSwitch:false,interval:3,
        cptTableData:[
            {"name":"显示文本","value":"","namekey":"label"},
            {"name":"值","value":"","namekey":"value"},
        ],
    },
    interaction:{multi:true}
}
